import { UseFormReturn } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import {
  Form,
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '@/components/ui/form';
import { Input } from '@/components/ui/input';
import { Switch } from '@/components/ui/switch';

type CreateFolderCardProps = {
  form: UseFormReturn<{ title?: string }>;
  enabled: boolean;
  onEnabledChange: (enabled: boolean) => void;
};

export const CreateFolderCard = ({ form, enabled, onEnabledChange }: CreateFolderCardProps) => {
  const { t } = useTranslation();

  return (
    <>
      <Switch
        variant="choice-card"
        switchPosition="right"
        label={t('collections.documents.create_folder')}
        description={t('collections.documents.group_uploaded_items_in_folder')}
        checked={enabled}
        onCheckedChange={onEnabledChange}
      />
      {enabled && (
        <div className="mt-4">
          <Form {...form}>
            <FormField
              control={form.control}
              name="title"
              render={({ field }) => (
                <FormItem>
                  <FormLabel className="text-sm font-medium">
                    {t('collections.documents.folder_name')}
                  </FormLabel>
                  <FormControl>
                    <Input autoFocus {...field} />
                  </FormControl>
                  <FormMessage />
                </FormItem>
              )}
            />
          </Form>
        </div>
      )}
    </>
  );
};
